import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Select from "react-select";
import useLang from "Shared/hooks/useLanguage";
import { reactSelectSMStyle2, styles } from "../../../../Utils/Common";

interface TransferTestsModalProps {
  show: boolean;
  onHide: () => void;
}

interface TestRow {
  id: number;
  testName: string;
  selectedLab: string;
}

const TransferTestsModal: React.FC<TransferTestsModalProps> = ({ show, onHide }) => {
  const { t } = useLang();

  // Static data - will be replaced with dynamic data later
  const [tests, setTests] = useState<TestRow[]>([
    { id: 1, testName: "Clarity", selectedLab: "" },
    { id: 2, testName: "GLUCOSE (GLU)", selectedLab: "" },
  ]);

  // Static lab options - will be replaced with dynamic data later
  const labOptions = [
    { value: "", label: "---select---" },
    { value: "lab1", label: "Lab 1" },
    { value: "lab2", label: "Lab 2" },
    { value: "lab3", label: "Lab 3" },
  ];

  const handleLabChange = (selectedOption: any, index: number) => {
    setTests((prevTests) =>
      prevTests.map((test, idx) =>
        idx === index ? { ...test, selectedLab: selectedOption?.value || "" } : test
      )
    );
  };

  const handleTransfer = () => {
    // TODO: Implement transfer logic when API is ready
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      keyboard={false}
    >
      <Modal.Header className="py-4 d-flex justify-content-between align-items-center">
        <Modal.Title className="h5">{t("Transfer Tests")}</Modal.Title>
        <IconButton
          onClick={onHide}
          aria-label="close"
          size="small"
          sx={{ ml: 2 }}
        >
          <CloseIcon />
        </IconButton>
      </Modal.Header>
      <Modal.Body>
        <div className="table_bordered overflow-hidden position-relative">
          <TableContainer className="shadow-none">
            <Table
              stickyHeader
              aria-label="sticky table collapsible"
              className="plate-mapping-table mb-1"
            >
              <TableHead className="h-40px">
                <TableRow>
                  <TableCell className="min-w-125px w-125px">
                    {t("Test")}
                  </TableCell>
                  <TableCell className="min-w-250px w-250px">
                    {t("Transfer to Lab")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tests.map((test, index) => (
                  <TableRow key={test.id}>
                    <TableCell>{test.testName}</TableCell>
                    <TableCell>
                      <Select
                        name="performingLab"
                        menuPortalTarget={document.body}
                        options={labOptions}
                        theme={(theme) => styles(theme)}
                        onChange={(e) => handleLabChange(e, index)}
                        value={labOptions.find(
                          (option) => option.value === test.selectedLab
                        )}
                        isSearchable={true}
                        styles={reactSelectSMStyle2("25px")}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Modal.Body>
      <Modal.Footer className="py-2">
        <button
          type="button"
          className="btn btn-sm btn-danger"
          onClick={onHide}
        >
          {t("Cancel")}
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={handleTransfer}
        >
          {t("Transfer")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TransferTestsModal;
